import { PDFOptions } from 'puppeteer-core';
import BwipJs from 'bwip-js';
import { IGerarPDFBradesco } from './types';
import maskFormat from '@/utils/maskFormat';
import { compileHbs } from '@/utils/compileHbs';
import { getPathTemplates } from '@/utils/getPathTemplates';
import { api } from '@/services/api';
import { decompress } from '@/utils/zip';

export async function gerarPDF({ dados }: IGerarPDFBradesco) {
  try {
    const { dadosPDF, generatePDF } = dados;

    const codigoBarra = await BwipJs.toBuffer({
      bcid: 'interleaved2of5',
      text: dadosPDF.boleto.codigoBarra,
      height: 20,
    });

    dadosPDF.beneficiario.dadosBancarios.agencia =
      dadosPDF.beneficiario.dadosBancarios.agencia.padStart(4, '0');
    dadosPDF.beneficiario.dadosBancarios.conta =
      dadosPDF.beneficiario.dadosBancarios.conta.padStart(7, '0');

    dadosPDF.boleto.codigoBarra = maskFormat.codigoBarra(dadosPDF.boleto.codigoBarra);
    dadosPDF.boleto.codigoBarraImage = codigoBarra.toString('base64');
    dadosPDF.beneficiario.cnpj = maskFormat.retornaCpfCnpjFormatado(
      dadosPDF.beneficiario.cnpj,
    );
    dadosPDF.beneficiario.endereco.cep = maskFormat.retornaCEPFormatado(
      dadosPDF.beneficiario.endereco.cep,
    );
    dadosPDF.pagador.endereco.cep = maskFormat.retornaCEPFormatado(
      dadosPDF.pagador.endereco.cep,
    );

    dadosPDF.boleto.valorAcrescimo = maskFormat.numberToReal(
      dadosPDF.boleto.valorAcrescimo,
    );
    dadosPDF.boleto.valorCobrado = maskFormat.numberToReal(
      dadosPDF.boleto.valorCobrado,
    );
    dadosPDF.boleto.valorDescontoAbatimento = maskFormat.numberToReal(
      dadosPDF.boleto.valorDescontoAbatimento,
    );
    dadosPDF.boleto.valorDocumento = maskFormat.numberToReal(
      dadosPDF.boleto.valorDocumento,
    );
    dadosPDF.boleto.valorMulta = maskFormat.numberToReal(dadosPDF.boleto.valorMulta);
    dadosPDF.boleto.valorOutrasDeducoes = maskFormat.numberToReal(
      dadosPDF.boleto.valorOutrasDeducoes,
    );

    if (dadosPDF.boleto.quantidade) {
      dadosPDF.boleto.quantidade = maskFormat.numberToReal(dadosPDF.boleto.quantidade);
    }

    dadosPDF.boleto.valor = maskFormat.numberToReal(dadosPDF.boleto.valor);

    const content = compileHbs(getPathTemplates('bradesco-boleto.hbs'), dadosPDF);

    const config: PDFOptions = {
      displayHeaderFooter: false,
      path: './boleto.pdf',
      format: 'a4',
      printBackground: true,
    };

    let pdfBase64: string | null = null;

    if (generatePDF) {
      pdfBase64 = await generatePDF(content, config);
    } else {
      if (!api.defaults.baseURL) {
        throw new Error('BaseURL api not found');
      }

      const response = await api.post('/', { content, config });
      const buffer = Buffer.from(response.data.pdf);
      pdfBase64 = await decompress(buffer);
    }

    return {
      erro: false,
      dados: pdfBase64,
    };
  } catch (error) {
    return {
      erro: true,
      dados: null,
    };
  }
}
